module.exports = __webpack_public_path__ + "img/Hands_Logo_Preto.21341294.png";